import React, { useEffect, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '../../context/Context';
import SmartLink from '../fragments/SmartLink';

const Header = () => {
    const { global, siteLoaded, toggleMenu, getGlobal } = useStore();
    const headerInnerRef = useRef(null);

    const handleMenuToggle = (evt) => {
        evt.preventDefault();
        toggleMenu();
    };

    const handleColorModeToggle = useCallback((evt) => {
        evt.preventDefault();
        
        // Toggle the state-reverse class on the html element
        const htmlElement = document.documentElement;
        htmlElement.classList.toggle('state-reverse');
    }, []);

    const updateHeaderHeight = useCallback(() => {
        if (headerInnerRef.current) {
            const height = headerInnerRef.current.clientHeight;
            console.log('header height', height);
            document.documentElement.style.setProperty('--header-height', `${height}px`);
        }
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            updateHeaderHeight();
        }, 0);

        window.addEventListener('resize', updateHeaderHeight);

        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('resize', updateHeaderHeight);
        };
    }, [updateHeaderHeight]);

    useEffect(() => {
        if (global.json) {
            const timeoutId = setTimeout(() => {
                updateHeaderHeight();
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, [global.json, updateHeaderHeight]);

    useEffect(() => {
        if (global.json === null && !global.globalFetched) {
            const globalUrl = `${window.location.origin}/wp-json/tenet/v1/global`;
            getGlobal(globalUrl);
        }
    }, [global.json, global.globalFetched, getGlobal]);

    if (!global.json && global.globalFetched) {
        return null;
    }

    if (!global.json) {
        return null;
    }

    console.log('global', global);

    return (
        <>
            <div className="c-header">
                <header className="c-header__inner" ref={headerInnerRef}>
                    <button 
                        className="c-header__color-mode-button" 
                        onClick={handleColorModeToggle}
                        aria-label="Toggle color mode"
                    >
                        <span className="c-header__color-mode-button__left"></span>
                        <span className="c-header__color-mode-button__right"></span>
                    </button>
                    <h2 className="c-header__logo">
                        <SmartLink
                            to="/" 
                            className="c-header__logo__inner" 
                            dangerouslySetInnerHTML={{
                                __html: '<svg width="100" height="21" viewBox="0 0 100 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0V2.46971H8.50819V20.1108H11.215V2.46971H19.6646V0H0Z" fill="black"/><path d="M21.7891 0V20.1108H38.1807V17.6411H24.4959V11.2903H36.8712V8.82057H24.4959V2.49903H37.8836V0H21.7891Z" fill="black"/><path d="M56.6644 0V16.5408H56.4552L43.7816 0H40.3008V20.1108H43.0089V3.54072H43.2167L55.8904 20.1108H59.3712V0H56.6644Z" fill="black"/><path d="M61.4922 0V20.1108H77.8838V17.6411H64.199V11.2903H76.5744V8.82057H64.199V2.49903H77.5855V0H61.4922Z" fill="black"/><path d="M79.7539 0V2.46971H88.2634V20.1108H90.9702V2.46971H99.4185V0H79.7539Z" fill="black"/></svg>'
                            }}
                        />
                    </h2>
                    <button 
                        type="button"
                        className="c-header__menu-button" 
                        onClick={handleMenuToggle}
                        aria-label="Toggle menu"
                    >
                        <span className="c-header__menu-button__text">Menu</span>
                        <span className="c-header__menu-button__text">Close</span>
                    </button>
                </header>
                <div className="c-header__menu">
                    <div className="c-header__menu__top"></div>
                    <nav className="c-header__menu__nav" aria-label="Primary">
                        <ul className="c-header__menu__list">
                            {global.json.menu.map((item, i) => (
                                <li className="c-header__menu__item" key={`m-${i}`}>
                                    <SmartLink
                                        to={item.url}
                                        className="c-header__menu__link"
                                        dangerouslySetInnerHTML={{ __html: item.title + '<span></span>'}}
                                    />
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div className="c-header__menu__footer">
                        <div className="l-grid">
                            <div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-5-12 l-grid__col--xl-4-12">
                                <div className="c-header__menu__footer__text scope-text--footer">
                                    {global.json.ftr_pos && (
                                        <div 
                                            className="c-header__menu__footer__pos-statement scope-text" 
                                            dangerouslySetInnerHTML={{ __html: global.json.ftr_pos }} 
                                        />
                                    )}
                                </div>
                                <ul className="c-header__menu__footer__social">
                                    {global.json.ftr_instagram && (
                                        <li className="c-header__menu__footer__social__item">
                                            <a
                                                className="c-header__menu__footer__social__link"
                                                href={global.json.ftr_instagram} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                            >
                                                Instagram
                                            </a>
                                        </li>
                                    )}

                                    {global.json.ftr_facebook && (
                                        <li className="c-header__menu__footer__social__item">
                                            <a 
                                                className="c-header__menu__footer__social__link"
                                                href={global.json.ftr_facebook} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                            >
                                                Facebook
                                            </a>
                                        </li>
                                    )}

                                    {global.json.ftr_pinterest && (
                                        <li className="c-header__menu__footer__social__item">
                                            <a 
                                                className="c-header__menu__footer__social__link"
                                                href={global.json.ftr_pinterest} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                            >
                                                Pinterest
                                            </a>
                                        </li>
                                    )}
                                    <li className="c-header__menu__footer__social__item" />
                                </ul>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            
        </>
    );
};

export default Header;
